import type { Ref } from "vue";

type UseDialogCloseOnBackdropOptions = {
  dialogContentRef: Ref<HTMLDivElement | null>;
  closeDialog: () => void;
};

const mouseEventIsInsideRect = (event: MouseEvent, rect: DOMRect) => {
  return (
    event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom
  );
};

export const useDialogCloseOnBackdrop = ({ dialogContentRef, closeDialog }: UseDialogCloseOnBackdropOptions) => {
  let mouseDownTarget: EventTarget | null = null;

  const dialogContentContainsTarget = (event: MouseEvent) => {
    const targetNode = event.target as Node | null;

    return Boolean(targetNode && dialogContentRef.value?.contains(targetNode));
  };

  const targetIsInsideRectOfDialogContent = (event: MouseEvent) => {
    const rect = dialogContentRef.value?.getBoundingClientRect();
    if (!rect || rect.width === 0 || rect.height === 0) return false;

    return mouseEventIsInsideRect(event, rect);
  };

  const isClickInsideContent = (event: MouseEvent) => {
    if (!dialogContentRef.value) return false;

    if (dialogContentContainsTarget(event)) return true;
    return targetIsInsideRectOfDialogContent(event);
  };

  const mouseDownTargetIsInsideDialogContent = () => {
    return mouseDownTarget instanceof HTMLElement && dialogContentRef.value?.contains(mouseDownTarget);
  };

  const trackMouseDown = (event: MouseEvent) => {
    mouseDownTarget = event.target;
  };

  const closeOnBackdropClick = (event?: Event) => {
    if (!(event instanceof MouseEvent)) {
      closeDialog();
      return;
    }

    if (isClickInsideContent(event) || mouseDownTargetIsInsideDialogContent()) return;

    closeDialog();
  };

  return {
    closeOnBackdropClick,
    trackMouseDown,
  };
};
